// Headline & per-pillar KPIs — Lenovo India CSR (FY 24-25)

export const HEADLINE_KPIS = {
  fy: "FY 2024-25",
  beneficiaries: { value: 31200, prev: 21400, label: "Students & youth reached", unit: "" },
  states:        { value: 14,    prev: 11,    label: "States reached" },
  districts:     { value: 34,    prev: 24,    label: "Districts reached" },
  partners:      { value: 11,    prev: 9,     label: "Implementation partners" },
  programSpendCr:{ value: 21.8,  prev: 17.8,  label: "Program spend",     unit: "₹ Cr" },
  econPotentialCr:{value: 95.0,  prev: 65.0,  label: "Economic potential unlocked", unit: "₹ Cr" },
  treesPlanted: { value: 240000, prev: 120000, label: "Trees planted (FY)" },
  co2Tonnes:    { value: 204000, prev: 102000, label: "CO₂ avoided (20-yr)", unit: "t" },
};

// Per-pillar KPIs (icon names must exist in PillarPage ICONS map)
export const PILLAR_KPIS = {
  stem: [
    { key: "studentsReached", value: 14800, label: "Students reached",       icon: "GraduationCap" },
    { key: "schoolsActive",   value: 940,   label: "Schools active",         icon: "BookOpen" },
    { key: "teachersTrained", value: 4350,  label: "Teachers trained",       icon: "Users" },
    { key: "stemLabs",        value: 98,    label: "STEM / innovation labs", icon: "Atom" },
  ],
  digital: [
    { key: "learnersReached", value: 11600, label: "Digital learners",       icon: "Laptop" },
    { key: "devicesDeployed", value: 16400, label: "Devices deployed",       icon: "Cpu" },
    { key: "girlsPct",        value: 47,    label: "Girl participation", unit:"%", icon: "User" },
    { key: "govtSchools",     value: 560,   label: "Govt schools onboarded", icon: "Wifi" },
  ],
  employability: [
    { key: "youthSkilled",   value: 6500, label: "Youth skilled",            icon: "GraduationCap" },
    { key: "placementRate",  value: 64,   label: "Placement rate",  unit:"%", icon: "Briefcase" },
    { key: "womenPct",       value: 43,   label: "Women in cohort", unit:"%", icon: "User" },
    { key: "econUnlockedCr", value: 28,   label: "Economic potential", unit:"₹ Cr", icon: "TrendingUp" },
  ],
  sustainability: [
    { key: "treesPlanted", value: 240000, label: "Trees planted (FY)",   icon: "TreePine" },
    { key: "ewasteTonnes", value: 6200,   label: "E-waste recycled (t)", icon: "Recycle" },
    { key: "communities",  value: 184,    label: "Villages reached",     icon: "Users" },
    { key: "co2Tonnes",    value: 204000, label: "CO₂ avoided (t)",      icon: "Leaf" },
  ],
};
